import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import {
    isEmpty,
    noop
} from 'lodash';
import {
    IDatiqGraph,
    IDatiqGraphSeries
} from '../models';
import { DatiqAmcharts5TooltipBuilder } from './datiq-amcharts-5-tooltip.builder';
import { datiqAmcharts5SetColor } from './models';

export class DatiqAmCharts5SeriesScatterBuilder {
    private _settings: Partial<am5xy.ILineSeriesSettings>;
    constructor() {}

    setDash(seriesData: IDatiqGraphSeries, series: am5xy.LineSeries) {
        seriesData?.dashed
            ? series?.strokes?.template.set('strokeDasharray', [3, 4])
            : noop();

        return this;
    }

    setStrokeWidth(seriesData: IDatiqGraphSeries, series: am5xy.LineSeries) {
        seriesData?.strokeWidth === 0
            ? series.strokes.template.setAll({
                  opacity: seriesData?.strokeWidth,
              })
            : noop();

        return this;
    }

    updateSeries(series: am5xy.LineSeries) {
        const settings: Partial<am5xy.ILineSeriesSettings> = this.build();

        series.setAll(settings);

        return this;
    }

    setTooltip(
        series: am5xy.LineSeries,
        root: am5.Root,
        seriesData: IDatiqGraphSeries,
        graph: IDatiqGraph
    ) {
        const tooltip: am5.Tooltip = new DatiqAmcharts5TooltipBuilder(
            series,
            root,
            seriesData,
            graph
        )
            .setLabel(graph, seriesData)
            .build();
        series.set('tooltip', tooltip);

        return this;
    }

    setBullets(
        series: am5xy.LineSeries,
        seriesData: IDatiqGraphSeries,
        root: am5.Root,
        graph: IDatiqGraph
    ): this {
        seriesData?.showBullets
            ? series.bullets.push((root) => {
                  return this.createBullet(root, series, seriesData, graph);
              })
            : noop();

        return this;
    }

    createBullet(
        root: am5.Root,
        series: am5xy.LineSeries,
        seriesData: IDatiqGraphSeries,
        graph: IDatiqGraph
    ): am5.Bullet {
        const circle = am5.Circle.new(root, {
            radius: 4,
            stroke: series.get('stroke'),
            fill: am5.color('#fff'),
            fillOpacity: 0
        });

        return am5.Bullet.new(root, {
            sprite: circle,
        });
    }

    setColor(seriesData: IDatiqGraphSeries) {
        this._settings = !!seriesData?.color?.length
            ? {
                  ...this._settings,
                  stroke: datiqAmcharts5SetColor(seriesData?.color),
              }
            : { ...this._settings };

        return this;
    }

    private setFill(seriesData: IDatiqGraphSeries) {
        return !isEmpty(seriesData?.ranged);
    }

    build(): Partial<am5xy.ILineSeriesSettings> {
        return this._settings;
    }
}
